import { render, staticRenderFns } from "./accountDetail.vue?vue&type=template&id=6e065034&scoped=true"
import script from "./accountDetail.vue?vue&type=script&lang=js"
export * from "./accountDetail.vue?vue&type=script&lang=js"
import style0 from "./accountDetail.vue?vue&type=style&index=0&id=6e065034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e065034",
  null
  
)

export default component.exports